let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bRfRr")).then(() => parcelRequire('7Lseo'));